import { render } from "./ReturnAdjustmentReasons.vue?vue&type=template&id=60d6295c"
import script from "./ReturnAdjustmentReasons.vue?vue&type=script&lang=js"
export * from "./ReturnAdjustmentReasons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/ReturnAdjustmentReasons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d6295c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d6295c', __exports__)) {
    api.reload('60d6295c', __exports__)
  }
  
  module.hot.accept("./ReturnAdjustmentReasons.vue?vue&type=template&id=60d6295c", () => {
    api.rerender('60d6295c', render)
  })

}


export default __exports__